import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { leadRef: String };

  connect() {
    this.startedAt = Date.now();
    this.scheduleTrack("page_view");
    document.addEventListener("turbo:before-visit", this.trackPageLeave);
    document.addEventListener("click", this.trackClick, { passive: true });
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.trackPageLeave);
    document.removeEventListener("click", this.trackClick);
  }

  trackPageLeave = () => {
    const duration = Math.round((Date.now() - this.startedAt) / 1000);
    this.scheduleTrack("page_leave", { duration });
  };

  trackClick = (event) => {
    const link = event.target.closest("a, button");
    if (!link) return;
    const label = link.getAttribute("aria-label") || link.textContent?.trim()?.slice(0, 80);
    if (label) this.scheduleTrack("click", { element: label });
  };

  scheduleTrack(eventType, extra = {}) {
    const run = () => this.track(eventType, extra);
    if ("requestIdleCallback" in window) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 0);
    }
  }

  track(eventType, extra = {}) {
    const ref = this.leadRefValue || this.readCookie("ss_lead_ref");
    fetch("/track/visitor", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
      },
      body: JSON.stringify({
        path: window.location.pathname,
        referrer: document.referrer,
        event_type: eventType,
        lead_ref: ref,
        duration: extra.duration,
        element: extra.element,
        utm_source: new URLSearchParams(window.location.search).get("utm_source"),
        utm_campaign: new URLSearchParams(window.location.search).get("utm_campaign"),
      }),
      keepalive: true,
    }).catch(() => {});
  }

  readCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : "";
  }
}
